/**
 * Shared behaviour for the DTF landing sections.
 *
 * The landing pages are built from many independent sections, so nothing here
 * assumes a single container. Everything is delegated off `document`, which
 * also means sections re-rendered by the theme editor keep working without
 * re-running any setup.
 *
 * Handles:
 *   .dtf-vplay[data-video-src]   opens the video in a shared lightbox
 *   [data-rev-nav][data-rev-target]  scrolls a horizontal card scroller
 *   [data-faq-toggle][data-faq-target]  expands a collapsed list
 *   .dtf-lp__sticky-cta          slides in once the visitor scrolls down
 */
(function () {
  if (window.__dtfLandingInit) return;
  window.__dtfLandingInit = true;

  /* ---------------------------------------------------------------- video */

  var modal = null;
  var modalVideo = null;

  function buildModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'dtf-vmodal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="dtf-vmodal-inner">' +
      '<button type="button" class="dtf-vmodal-close" aria-label="Close video">&times;</button>' +
      '<video controls playsinline preload="none"></video>' +
      '</div>';

    document.body.appendChild(modal);
    modalVideo = modal.querySelector('video');

    modal.addEventListener('click', function (e) {
      var onBackdrop = e.target === modal;
      var onClose = e.target.classList && e.target.classList.contains('dtf-vmodal-close');
      if (onBackdrop || onClose) closeVideo();
    });

    return modal;
  }

  function openVideo(src) {
    buildModal();
    modalVideo.src = src;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var played = modalVideo.play();
    if (played && played.catch) played.catch(function () {});
  }

  function closeVideo() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    try {
      modalVideo.pause();
    } catch (e) {}
    modalVideo.removeAttribute('src');
    modalVideo.load();
    document.documentElement.style.overflow = '';
  }

  /* -------------------------------------------------------------- scroller */

  function scrollCards(btn) {
    var scroller = document.getElementById(btn.getAttribute('data-rev-target'));
    if (!scroller) return;

    var direction = btn.getAttribute('data-rev-nav') === 'next' ? 1 : -1;
    var card = scroller.querySelector('[data-rev]');
    var gap = parseFloat(getComputedStyle(scroller).columnGap) || 20;
    var step = card ? card.offsetWidth + gap : scroller.clientWidth;

    scroller.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  /* ------------------------------------------------------------ faq toggle */

  function toggleFaq(btn) {
    var wrap = document.getElementById(btn.getAttribute('data-faq-target'));
    if (!wrap) return;

    var isHidden = wrap.style.display === 'none' || wrap.style.display === '';
    wrap.style.display = isHidden ? 'flex' : 'none';
    btn.textContent = isHidden
      ? btn.getAttribute('data-faq-less') || 'Show less ↑'
      : btn.getAttribute('data-faq-more') || 'Show all questions ↓';
  }

  /* ------------------------------------------------------------ delegation */

  document.addEventListener('click', function (e) {
    var play = e.target.closest ? e.target.closest('.dtf-vplay') : null;
    if (play) {
      var src = play.getAttribute('data-video-src');
      if (src) {
        e.preventDefault();
        openVideo(src);
      }
      return;
    }

    var nav = e.target.closest ? e.target.closest('[data-rev-nav]') : null;
    if (nav) {
      scrollCards(nav);
      return;
    }

    var faq = e.target.closest ? e.target.closest('[data-faq-toggle]') : null;
    if (faq) toggleFaq(faq);
  });

  document.addEventListener('keydown', function (e) {
    var isEscape = e.key === 'Escape' || e.keyCode === 27;
    if (isEscape && modal && modal.classList.contains('is-open')) closeVideo();
  });

  /* ----------------------------------------------------------- sticky cta */

  function toggleStickyCta() {
    var bars = document.querySelectorAll('.dtf-lp__sticky-cta');
    if (!bars.length) return;

    var past = window.scrollY > window.innerHeight * 0.4;
    for (var i = 0; i < bars.length; i++) {
      bars[i].classList.toggle('is-visible', past);
    }
  }

  window.addEventListener('scroll', toggleStickyCta, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', toggleStickyCta);
  } else {
    toggleStickyCta();
  }
})();
